export default __webpack_public_path__ + "static/media/nothing-found.e8b19be7.png";